module.exports = __webpack_public_path__ + "img/middle.745c7607.png";